module.exports = __webpack_public_path__ + "img/sc-3p-2023.44cb8712.jpg";